import { Component, computed, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FiltersFacade } from '../../state/filters.facade';
import { Filter } from '../../services/models/filter.model';

@Component({
  selector: 'app-filter-list-dialog',
  templateUrl: './filter-list-dialog.component.html',
  styleUrls: ['./filter-list-dialog.component.scss']
})
export class FilterListDialogComponent {
  private readonly filtersFacade = inject(FiltersFacade);

  @Input() open: boolean
  @Input() initialParams: Record<string, string | number | boolean>;
  @Input() filterName: string;
  @Output() closed = new EventEmitter<{ name: string, value: string } | undefined>();

  readonly isLoading = toSignal(this.filtersFacade.isLoading$);
  readonly isLoadingSearch = toSignal(this.filtersFacade.isLoadingSearch$);
  readonly filter = toSignal(this.filtersFacade.filter$);
  readonly filterValues = toSignal(this.filtersFacade.filterValues$);
  readonly pagination = toSignal(this.filtersFacade.pagination$);
  readonly hasMore = computed(() => this.pagination().total >= this.pagination().page * this.pagination().size);
  readonly searchTerm = signal<string>('');
  readonly filterValuesTrackByFn = (_: number, filterValue: Filter) => filterValue.name;

  closeDialog(value?: { name: string, value: string }) {
    this.searchTerm.set('');
    this.filtersFacade.clearFilter();
    this.closed.emit(value);
  }

  search(query: string) {
    this.searchTerm.set(query);
    this.filtersFacade.getFilter(this.filter().name, {
      facetSearch: query,
      offset: 0,
      ...this.initialParams,
    });
  }

  loadFilter() {
    this.filtersFacade.getFilter(this.filterName, this.initialParams);
  }

  loadMore() {
    this.filtersFacade.getFilter(this.filter().name, {
      facetSearch: this.searchTerm(),
      offset: (this.pagination().page - 1) * this.pagination().size + this.pagination().size,
      ...this.initialParams,
    });
  }
}
